module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-7.3fc81ff7.svg";